import request from '@/config/axios';

// 数字人 生成记录 VO
export interface AiAvatarVO {
  id: number; // 编号
  userId: number; // 用户id
  platform: string; // 平台
  modelId: number; // 模型id
  model: string; // 模型
  title: string; // 名称
  videoUrl: string; // 视频地址
  fileId: string; // 文件id
  taskId: string; // 任务编号
  status: number; // 状态
  finishTime: string; // 完成时间
  options: string; // 选项
  errorMessage: string; // 错误信息
  duration: number; // 时长
  avatar: string; // 数字人标识
  publicStatus: boolean; // 公开状态
  applyPublish: boolean; // 申请发布状态
  createTime: string; // 创建时间
  isLike: boolean; // 是否点赞
  browseCount: number; // 浏览次数
  likeCount: number; // 点赞次数
}

export const AiAvatarRecordApi = {
  // 获取分页
  getList: async (params: any): Promise<PageResult<AiAvatarVO[]>> => {
    return await request.get({ url: `/ai/avatar-video/page`, params });
  },

  // 详情
  get: async (id: number) => {
    return await request.get({ url: `` });
  },

  // 更新绘画发布状态
  update: async (data: any) => {
    return await request.put({ url: '', data });
  },

  // 删除绘画
  delete: async (id: number) => {
    return await request.delete({ url: `?id=` + id });
  },

  // 发布
  audits: async (data: { id: Number; publicStatus: Boolean }) => {
    return await request.post({ url: '', data });
  },

  // 申请发布
  apply: async (data: { id: Number; applyPublish: Boolean }) => {
    return await request.post({ url: '', data });
  },
};
